module.exports = __webpack_public_path__ + "img/EMT-NPC_GSE200310.6fff6a09.png";